export default "__VITE_ASSET__0ceb6937__"